export default __webpack_public_path__ + "static/media/map-marker-white.2566985c.svg";